// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3k2oD","detailsBorder":"styles_detailsBorder__3BL8D"};